import { type FC, type ReactNode } from 'react';

import StyledContent from './styles';

const Content: FC<{ children: ReactNode }> = ({ children }) => {
  return <StyledContent>{children}</StyledContent>;
};

export default Content;
